export enum MarketingAutomationEnum {
  FLAVO_C_10 = '015',
  FLAVO_C_30 = '016',
  LAMBDAPIL_FORTE = '081',
  ESSENTIAL_CLEANSING = '055',
  ESSENTIAL_CLEANSING_SAMPLE_122 = '122',
  ESSENTIAL_CLEANSING_SAMPLE_123 = '123',
  ESSENTIAL_CLEANSING_SAMPLE_126 = '126',
  ESSENTIAL_CLEANSING_SAMPLE_127 = '127',
  ESSENTIAL_CLEANSING_SAMPLE_128 = '128',
  ESSENTIAL_CLEANSING_SAMPLE_129 = '129',
  RETINAL_INTENSE = '000000000190020071',

}

const FLAVO_C_JOURNEYS = [
  MarketingAutomationEnum.FLAVO_C_10.toString(),
  MarketingAutomationEnum.FLAVO_C_30.toString(),
];
const CLEANSING_JOURNEYS = [
  MarketingAutomationEnum.ESSENTIAL_CLEANSING.toString(),
  MarketingAutomationEnum.ESSENTIAL_CLEANSING_SAMPLE_122.toString(),
  MarketingAutomationEnum.ESSENTIAL_CLEANSING_SAMPLE_123.toString(),
  MarketingAutomationEnum.ESSENTIAL_CLEANSING_SAMPLE_126.toString(),
  MarketingAutomationEnum.ESSENTIAL_CLEANSING_SAMPLE_127.toString(),
  MarketingAutomationEnum.ESSENTIAL_CLEANSING_SAMPLE_128.toString(),
  MarketingAutomationEnum.ESSENTIAL_CLEANSING_SAMPLE_129.toString(),
];
const RETINAL_INTENSE_JOURNEY = [
  MarketingAutomationEnum.RETINAL_INTENSE.toString()
]

export const getJourneyIds = (consumedQrs: ConsumedQR[]): string[] => {
  const journeyProducts = consumedQrs.filter(({ entityId }) => {
    const validValues: string[] = Object.values(MarketingAutomationEnum);
    return validValues.includes(entityId);
  });

  if (!journeyProducts?.length) return [];

  const groupedProducts: ConsumedQR[] = [];

  for (const value in MarketingAutomationEnum) {
    const productGroup = [...journeyProducts].filter(
      (p) => p.entityId === MarketingAutomationEnum[value]
    );

    if (!productGroup?.length) continue;

    if (productGroup?.length > 1) {
      productGroup.sort(
        (a, b) =>
          new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
      );
    }

    groupedProducts.push(productGroup[0]);
  }

  const userJourneys = cleanGroupJourneys(groupedProducts);

  return userJourneys?.map((product) => product.entityId) || [];
};

const cleanGroupJourneys = (products: ConsumedQR[]) => {
  const userJourneys = products.filter(
    ({ entityId }) =>
      ![...FLAVO_C_JOURNEYS, ...CLEANSING_JOURNEYS, ...RETINAL_INTENSE_JOURNEY].includes(entityId)
  );

  // remove all flavo-c journeys except newest
  const flavoCJourneys = products.filter(({ entityId }) =>
    FLAVO_C_JOURNEYS.includes(entityId)
  );

  if (flavoCJourneys?.length >= 1) {
    flavoCJourneys.sort(
      (a, b) =>
        new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
    );
    userJourneys.push(flavoCJourneys[0]);
  }

  // remove all cleansing journeys except newest
  const cleansingJourneys = products.filter(({ entityId }) =>
    CLEANSING_JOURNEYS.includes(entityId)
  );

  if (cleansingJourneys?.length >= 1) {
    cleansingJourneys.sort(
      (a, b) =>
        new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
    );
    userJourneys.push(cleansingJourneys[0]);
  }

  const retinalJourney = products.filter(({entityId}) =>
    RETINAL_INTENSE_JOURNEY.includes(entityId)
    );
  if(retinalJourney?.length >= 1){
    retinalJourney.sort(
      (a, b)=>
      new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
    );
    userJourneys.push(retinalJourney[0]);
  }

  return userJourneys;
};

export interface ConsumedQR {
  entityId: string;
  createdAt: Date;
}
